import React from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import NavigationButtons from '../components/NavigationButtons';
import { CONTRACEPTION_OPTIONS } from '../constants/contraception';

const OnboardingContraception = () => {
  const { formData, updateField } = useOnboarding();

  return (
    <PageLayout step={5}>
      <h2 className="title">Quel est votre type de contraception</h2>
      <p className="subtitle">
        Pilule, stérilet, autre ou précisez si vous n'avez pas de contraception
      </p>

      <div className="form-group">
        <select
          id="contraception"
          name="contraception"
          value={formData.contraception}
          onChange={(e) => updateField('contraception', e.target.value)}
          className="form-input form-select"
        >
          <option value="">Sélectionner une option</option>
          {CONTRACEPTION_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <NavigationButtons
        nextPath="/onboarding/cycle"
        prevPath="/onboarding/sport"
      />
    </PageLayout>
  );
};

export default OnboardingContraception;
